<template>
  <Layout tituloPagina="Sistema | Ajustes | WhatsApp Business">
    <div class="card shadow-sm">
      <div class="card-header justify-content-between d-flex align-items-center">
        <div class="d-flex align-items-center">
          <i class="mdi mdi-whatsapp text-success font-size-24 me-2"></i>
          <h4 class="card-title mb-0 font-size-16">
            Ajustes de WhatsApp Business
          </h4>
          <span class="badge bg-success ms-3" v-if="ajustes.whatsapp_activo">
            <i class="mdi mdi-circle me-1 font-size-10"></i>Activo
          </span>
          <span class="badge bg-secondary ms-3" v-else>
            <i class="mdi mdi-circle-outline me-1 font-size-10"></i>Inactivo
          </span>
        </div>
        <div>
          <div class="dropdown">
            <a
              class="dropdown-toggle"
              href="javascript: void(0);"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <eva-icon
                name="more-horizontal-outline"
                data-eva-width="20"
                data-eva-height="20"
                :class="{
                  'fill-dark': $store.state.layout.layoutMode == 'light',
                  'fill-white': $store.state.layout.layoutMode == 'dark'
                }"
              ></eva-icon>
            </a>
            <ul class="dropdown-menu dropdown-menu-end shadow">
              <li>
                <a
                  href="#"
                  class="dropdown-item"
                  onclick="return false"
                  @click="actualizarConfiguracion()"
                  v-if="!bandera_spinner"
                >
                  <i class="mdi mdi-content-save text-success me-2"></i>
                  Guardar Configuración
                </a>
                <span class="dropdown-item disabled" v-if="bandera_spinner">
                  <i class="mdi mdi-concourse-ci mdi-spin me-2"></i>
                  Guardando...
                </span>
              </li>
              <li>
                <a
                  href="#"
                  class="dropdown-item"
                  onclick="return false"
                  @click="enviarMensajePrueba()"
                >
                  <i class="mdi mdi-send-check text-primary me-2"></i>
                  Probar conexión
                </a>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  onclick="return false;"
                  @click="$router.go(-1)"
                >
                  <i class="mdi mdi-close text-dark me-2"></i>
                  Cerrar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Pestañas de Navegación -->
      <div class="card-header border-bottom p-0">
        <ul class="nav nav-tabs nav-tabs-custom px-3 border-bottom-0" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link cursor py-3"
              :class="{ active: tabActiva == 'configuracion' }"
              @click="cambiarTab('configuracion')"
              role="tab"
            >
              <i class="mdi mdi-cog-outline me-1 font-size-16"></i>
              Configuración y API
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link cursor py-3"
              :class="{ active: tabActiva == 'plantillas' }"
              @click="cambiarTab('plantillas')"
              role="tab"
            >
              <i class="mdi mdi-file-document-edit-outline me-1 font-size-16"></i>
              Plantillas de WhatsApp (Templates)
              <span class="badge bg-primary ms-1 rounded-pill">{{ plantillas.length }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link cursor py-3"
              :class="{ active: tabActiva == 'respuestas' }"
              @click="cambiarTab('respuestas')"
              role="tab"
            >
              <i class="mdi mdi-lightning-bolt-outline me-1 font-size-16"></i>
              Respuestas Rápidas
              <span class="badge bg-success ms-1 rounded-pill">{{ respuestasRapidas.length }}</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="card-body p-4">
        <!-- Pestaña 1: Configuración y API -->
        <CmpConfiguracionApi
          v-show="tabActiva == 'configuracion'"
          :ajustes="ajustes"
          :bandera-spinner="bandera_spinner"
          :bandera-prueba="bandera_prueba"
          :telefono-prueba="telefono_prueba"
          @update:telefono-prueba="telefono_prueba = $event"
          :respuesta-prueba="respuesta_prueba"
          :estado-respuesta-prueba="estado_respuesta_prueba"
          @update-ajustes="Object.assign(ajustes, $event)"
          @guardar="actualizarConfiguracion"
          @enviar-prueba="enviarMensajePrueba"
          @limpiar-respuesta="respuesta_prueba = null"
          @habilitar-servicio="ajustes.whatsapp_activo = true; actualizarConfiguracion()"
        />

        <!-- Pestaña 2: Plantillas de WhatsApp -->
        <CmpPlantillasWhatsapp
          v-show="tabActiva == 'plantillas'"
          :ajustes="ajustes"
          :plantillas="plantillas"
          :plantilla="plantillaActual"
          :plantilla-seleccionada-idx="plantillaSeleccionadaIdx"
          :grupos-variables="gruposVariables"
          :bandera-spinner="bandera_spinner"
          :bandera-crear="bandera_crear_meta"
          :bandera-actualizar="bandera_actualizar_meta"
          :bandera-consultar="bandera_consultar_meta"
          :bandera-eliminando="bandera_eliminando_meta"
          :respuesta-meta="respuestaMetaPlantilla"
          :nombre-empresa="nombreEmpresa"
          @seleccionar-plantilla="plantillaSeleccionadaIdx = $event"
          @update-plantilla="alActualizarPlantillaLocal($event)"
          @consultar-meta="consultarEstadoPlantillasMeta(true)"
          @guardar-plantillas="guardarPlantillasDesdeEditor($event)"
          @crear-meta="crearPlantillaEnMeta($event)"
          @actualizar-meta="actualizarPlantillaEnMeta($event)"
          @eliminar-meta="confirmarEliminarPlantillaEnMeta($event)"
          @restablecer="restablecerPlantillaPorDefecto(plantillaSeleccionadaIdx)"
          @cambiar-idioma="alCambiarIdioma"
          @ir-a-configuracion="cambiarTab('configuracion')"
          @limpiar-respuesta-meta="respuestaMetaPlantilla = null"
          @habilitar-servicio="ajustes.whatsapp_activo = true; actualizarConfiguracion()"
        />

        <!-- Pestaña 3: Respuestas Rápidas -->
        <CmpRespuestasRapidasWhatsapp
          v-show="tabActiva == 'respuestas'"
          :respuestas="respuestasRapidas"
          :grupos-variables="gruposVariables"
          :bandera-spinner="bandera_spinner"
          @update:respuestas="respuestasRapidas = $event"
          @guardar="guardarRespuestasRapidasEnStorage"
        />
      </div>
    </div>

    <!-- Modal: Plantillas Registradas en Meta Cloud API -->
    <MdlPlantillasMeta
      :mostrar="mostrarModalPlantillasMeta"
      :waba-id="ajustes.whatsapp_business_account_id"
      :plantillas="plantillasDelSistemaEnMeta"
      :cargando="bandera_consultar_meta"
      :eliminando="bandera_eliminando_meta"
      @cerrar="mostrarModalPlantillasMeta = false"
      @refrescar="consultarEstadoPlantillasMeta(true, true)"
      @guardar-sincronizacion="guardarSincronizacionMeta"
      @eliminar="confirmarEliminarPlantillaEnMeta"
    />
    <br/>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/main'
import SistemaSrv from '@/services/SistemaSrv.js'
import SitioSrv from '@/services/SitioSrv.js'
import Swal from 'sweetalert2'
import CmpConfiguracionApi from './whatsappBusiness/CmpConfiguracionApi.vue'
import CmpPlantillasWhatsapp from './whatsappBusiness/CmpPlantillasWhatsapp.vue'
import CmpRespuestasRapidasWhatsapp, { RESPUESTAS_RAPIDAS_PREDETERMINADAS } from './whatsappBusiness/CmpRespuestasRapidasWhatsapp.vue'
import MdlPlantillasMeta from './whatsappBusiness/MdlPlantillasMeta.vue'
import {
  PLANTILLAS_PREDETERMINADAS,
  GRUPOS_VARIABLES,
  etiquetaEstadoMeta
} from './whatsappBusiness/whatsappConstants.js'

export default {
  name: 'WhatsappBusiness',
  components: {
    Layout,
    CmpConfiguracionApi,
    CmpPlantillasWhatsapp,
    CmpRespuestasRapidasWhatsapp,
    MdlPlantillasMeta
  },
  data() {
    return {
      tabActiva: 'configuracion',
      bandera_spinner: false,
      bandera_prueba: false,
      bandera_crear_meta: false,
      bandera_actualizar_meta: false,
      bandera_consultar_meta: false,
      bandera_eliminando_meta: null,
      telefono_prueba: '+52-55-12312312',
      respuesta_prueba: null,
      estado_respuesta_prueba: null,
      respuestaMetaPlantilla: null,
      plantillasMetaCargadas: [],
      mostrarModalPlantillasMeta: false,
      plantillaSeleccionadaIdx: 0,
      ultimaConsultaMetaTimestamp: 0,
      ajustes: {
        whatsapp_activo: false,
        whatsapp_numero_telefono: '',
        whatsapp_phone_number_id: '',
        whatsapp_business_account_id: '',
        whatsapp_token: '',
        whatsapp_app_id: '',
        whatsapp_app_secret: '',
        whatsapp_webhook_token: '',
        whatsapp_plantillas: '',
        whatsapp_plantilla_confirmacion_pago: '',
        whatsapp_plantilla_inicio_conversacion: '',
        whatsapp_respuestas_rapidas: ''
      },
      gruposVariables: GRUPOS_VARIABLES,
      plantillas: JSON.parse(JSON.stringify(PLANTILLAS_PREDETERMINADAS)),
      respuestasRapidas: JSON.parse(JSON.stringify(RESPUESTAS_RAPIDAS_PREDETERMINADAS))
    }
  },

  computed: {
    plantillasDelSistemaEnMeta() {
      if (!this.plantillasMetaCargadas || !Array.isArray(this.plantillasMetaCargadas)) return []
      let nombres = (this.plantillas || []).map(p => (p.nombre_meta || '').toLowerCase())
      return this.plantillasMetaCargadas.filter(m => nombres.includes((m.name || '').toLowerCase()))
    },
    plantillaActual() {
      return this.plantillas[this.plantillaSeleccionadaIdx] || null
    },
    nombreEmpresa() {
      return this.$store.state.todo.nombre_empresa || 'ArgusBlack ISP'
    }
  },

  created() {
    this.cargarAjustes()
  },

  methods: {
    etiquetaEstadoMeta,

    cargarAjustes() {
      let self = this
      let nombres = Object.keys(self.ajustes)

      SistemaSrv.ajustes(nombres).then(response => {
        let datos = response.data || {}
        nombres.forEach(key => {
          if (datos[key] !== undefined && datos[key] !== null && datos[key] !== '') {
            self.ajustes[key] = typeof self.ajustes[key] === 'boolean'
              ? ['1', 1, 'true', true].includes(datos[key])
              : datos[key]
          }
        })
        self.inicializarPlantillas()
        self.inicializarRespuestasRapidas()
        if (self.ajustes.whatsapp_token && self.ajustes.whatsapp_business_account_id) {
          self.consultarEstadoPlantillasMeta(false)
        }
      }).catch(() => {
        let cached = localStorage.getItem('argusblack.ajustes_whatsapp')
        if (cached) {
          try {
            self.ajustes = Object.assign({}, self.ajustes, JSON.parse(cached))
          } catch (e) {
            console.error('Error al recuperar caché:', e)
          }
        }
        self.inicializarPlantillas()
        self.inicializarRespuestasRapidas()
        if (self.ajustes.whatsapp_token && self.ajustes.whatsapp_business_account_id) {
          self.consultarEstadoPlantillasMeta(false)
        }
      })
    },

    inicializarRespuestasRapidas() {
      let self = this
      SitioSrv.obtenerRespuestasRapidasWhatsapp()
        .then((response) => {
          if (Array.isArray(response.data) && response.data.length > 0) {
            self.respuestasRapidas = response.data
            localStorage.setItem('argusblack.ajustes_whatsapp_respuestas_rapidas', JSON.stringify(response.data))
            return
          }
          self.cargarRespuestasRapidasDeCacheLocal()
        })
        .catch(() => {
          self.cargarRespuestasRapidasDeCacheLocal()
        })
    },

    cargarRespuestasRapidasDeCacheLocal() {
      let raw = localStorage.getItem('argusblack.ajustes_whatsapp_respuestas_rapidas')
      if (raw) {
        try {
          let parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.respuestasRapidas = parsed
            return
          }
        } catch (e) {
          console.error('Error al parsear respuestas rápidas:', e)
        }
      }
      this.respuestasRapidas = JSON.parse(JSON.stringify(RESPUESTAS_RAPIDAS_PREDETERMINADAS))
    },

    inicializarPlantillas(cadenaPlantillas) {
      let base = JSON.parse(JSON.stringify(PLANTILLAS_PREDETERMINADAS))

      // 1. Intentar cargar desde los ajustes individuales dedicados
      let rawConfPago = this.ajustes.whatsapp_plantilla_confirmacion_pago || localStorage.getItem('argusblack.ajustes_whatsapp_plantilla_confirmacion_pago')
      let rawInicioConv = this.ajustes.whatsapp_plantilla_inicio_conversacion || localStorage.getItem('argusblack.ajustes_whatsapp_plantilla_inicio_conversacion')

      let parseObj = function(raw) {
        if (!raw) return null
        if (typeof raw === 'object') return raw
        try {
          return JSON.parse(raw)
        } catch (e) {
          return null
        }
      }

      let objConfPago = parseObj(rawConfPago)
      let objInicioConv = parseObj(rawInicioConv)

      // 2. Fallback a whatsapp_plantillas si no hay ajustes individuales
      let rawPlantillas = cadenaPlantillas || this.ajustes.whatsapp_plantillas || localStorage.getItem('argusblack.ajustes_whatsapp_plantillas')
      let arrPlantillas = parseObj(rawPlantillas)
      if (arrPlantillas && !Array.isArray(arrPlantillas)) {
        arrPlantillas = [arrPlantillas]
      }

      base.forEach(pBase => {
        let guardada = null
        if (pBase.id === 'confirmacion_pago' && objConfPago) {
          guardada = objConfPago
        } else if (pBase.id === 'inicio_conversacion' && objInicioConv) {
          guardada = objInicioConv
        } else if (Array.isArray(arrPlantillas)) {
          guardada = arrPlantillas.find(p => p.id === pBase.id || p.nombre_meta === pBase.nombre_meta)
        }

        if (guardada) {
          Object.assign(pBase, {
            icono: pBase.id === 'confirmacion_pago' ? 'mdi mdi-receipt' : 'mdi mdi-message-text-outline',
            categoria: guardada.categoria || pBase.categoria || 'UTILITY',
            idioma: guardada.idioma || pBase.idioma || 'es_MX',
            idioma_registrado_meta: guardada.idioma_registrado_meta || guardada.idioma || null,
            estado_meta: guardada.estado_meta || 'NO_REGISTRADA',
            id_meta: guardada.id_meta || null,
            tipo_encabezado: guardada.tipo_encabezado || pBase.tipo_encabezado,
            encabezado: guardada.encabezado !== undefined ? guardada.encabezado : pBase.encabezado,
            url_imagen_encabezado: guardada.url_imagen_encabezado !== undefined ? guardada.url_imagen_encabezado : pBase.url_imagen_encabezado,
            cuerpo: guardada.cuerpo || pBase.cuerpo,
            pie: pBase.id === 'inicio_conversacion' ? '' : (guardada.pie !== undefined ? guardada.pie.replace(/\{\{[^}]+\}\}/g, '').trim() : (pBase.pie || ''))
          })
        }
      })

      this.plantillas = base
      this.actualizarAjustesPlantillasLocales()
    },

    actualizarAjustesPlantillasLocales() {
      let confirmacionPagoTpl = this.plantillas.find(p => p.id === 'confirmacion_pago')
      let inicioConversacionTpl = this.plantillas.find(p => p.id === 'inicio_conversacion')

      this.ajustes.whatsapp_plantillas = JSON.stringify(this.plantillas)
      this.ajustes.whatsapp_plantilla_confirmacion_pago = confirmacionPagoTpl ? JSON.stringify(confirmacionPagoTpl) : ''
      this.ajustes.whatsapp_plantilla_inicio_conversacion = inicioConversacionTpl ? JSON.stringify(inicioConversacionTpl) : ''

      localStorage.setItem('argusblack.ajustes_whatsapp_plantillas', this.ajustes.whatsapp_plantillas)
      if (this.ajustes.whatsapp_plantilla_confirmacion_pago) {
        localStorage.setItem('argusblack.ajustes_whatsapp_plantilla_confirmacion_pago', this.ajustes.whatsapp_plantilla_confirmacion_pago)
      }
      if (this.ajustes.whatsapp_plantilla_inicio_conversacion) {
        localStorage.setItem('argusblack.ajustes_whatsapp_plantilla_inicio_conversacion', this.ajustes.whatsapp_plantilla_inicio_conversacion)
      }
    },

    alActualizarPlantillaLocal(tpl) {
      if (tpl && this.plantillaSeleccionadaIdx >= 0 && this.plantillas[this.plantillaSeleccionadaIdx]) {
        Object.assign(this.plantillas[this.plantillaSeleccionadaIdx], tpl)
        this.actualizarAjustesPlantillasLocales()
      }
    },

    guardarPlantillasDesdeEditor(tpl) {
      let tplActual = tpl || this.plantillaActual
      if (tplActual && this.plantillaSeleccionadaIdx >= 0 && this.plantillas[this.plantillaSeleccionadaIdx]) {
        Object.assign(this.plantillas[this.plantillaSeleccionadaIdx], tplActual)
      }
      this.actualizarConfiguracion()
    },

    restablecerPlantillaPorDefecto(idx) {
      let actual = this.plantillas[idx]
      let defaultTpl = PLANTILLAS_PREDETERMINADAS.find(p => p.id === actual.id)
      if (defaultTpl) {
        Object.assign(this.plantillas[idx], JSON.parse(JSON.stringify(defaultTpl)))
        this.actualizarAjustesPlantillasLocales()
        iu.msg.success(`Plantilla "${actual.titulo}" restablecida a valores predeterminados`)
      }
    },

    actualizarConfiguracion() {
      let self = this
      self.bandera_spinner = true

      self.actualizarAjustesPlantillasLocales()

      let datosConfig = {
        whatsapp_activo: self.ajustes.whatsapp_activo,
        whatsapp_numero_telefono: self.ajustes.whatsapp_numero_telefono,
        whatsapp_phone_number_id: self.ajustes.whatsapp_phone_number_id,
        whatsapp_business_account_id: self.ajustes.whatsapp_business_account_id,
        whatsapp_token: self.ajustes.whatsapp_token,
        whatsapp_app_id: self.ajustes.whatsapp_app_id,
        whatsapp_app_secret: self.ajustes.whatsapp_app_secret,
        whatsapp_webhook_token: self.ajustes.whatsapp_webhook_token,
        whatsapp_plantillas: self.ajustes.whatsapp_plantillas,
        whatsapp_plantilla_confirmacion_pago: self.ajustes.whatsapp_plantilla_confirmacion_pago,
        whatsapp_plantilla_inicio_conversacion: self.ajustes.whatsapp_plantilla_inicio_conversacion
      }

      SitioSrv.actualizarAjustesWhatsapp(datosConfig).then(() => {
        let ajustesGuardados = JSON.parse(localStorage.getItem('argusblack.ajustes_whatsapp') || '{}')
        Object.assign(ajustesGuardados, datosConfig)
        localStorage.setItem('argusblack.ajustes_whatsapp', JSON.stringify(ajustesGuardados))
        iu.msg.success('Configuración y plantillas de WhatsApp guardadas correctamente')
      }).catch(error => {
        let errData = error.response ? error.response.data : {}
        let msg = errData.message || (errData.error && errData.error.message) || 'Error al guardar la configuración'
        iu.msg.error(msg)
      }).finally(() => {
        self.bandera_spinner = false
      })
    },

    guardarRespuestasRapidasEnStorage() {
      let self = this
      self.bandera_spinner = true

      SitioSrv.guardarRespuestasRapidasWhatsapp(self.respuestasRapidas)
        .then(() => {
          localStorage.setItem('argusblack.ajustes_whatsapp_respuestas_rapidas', JSON.stringify(self.respuestasRapidas || []))
          iu.msg.success('Respuestas rápidas guardadas correctamente en storage')
        })
        .catch(error => {
          let errData = error.response ? error.response.data : {}
          let msg = errData.message || (errData.error && errData.error.message) || 'Error al guardar respuestas rápidas'
          iu.msg.error(msg)
        })
        .finally(() => {
          self.bandera_spinner = false
        })
    },

    guardarSincronizacionMeta() {
      this.actualizarConfiguracion()
      this.mostrarModalPlantillasMeta = false
    },

    enviarMensajePrueba() {
      let self = this
      if (!self.ajustes.whatsapp_activo) {
        iu.msg.warning('WhatsApp Business se encuentra desactivado. Active el servicio para realizar pruebas.')
        return
      }
      if (!self.ajustes.whatsapp_phone_number_id || !self.ajustes.whatsapp_token) {
        iu.msg.warning('Configure el Phone Number ID y el Token de Acceso en Credenciales.')
        return
      }
      let toNum = (self.telefono_prueba || '').replace(/[^0-9]/g, '')
      if (!toNum) {
        iu.msg.warning('Ingrese un número telefónico de destinatario válido con lada de país.')
        return
      }

      self.bandera_prueba = true
      self.respuesta_prueba = null
      self.estado_respuesta_prueba = null

      let payload = {
        to: toNum,
        template: 'hello_world',
        language: 'en_US'
      }

      SitioSrv.testWhatsapp(payload).then(response => {
        self.respuesta_prueba = response.data
        self.estado_respuesta_prueba = 'success'
        iu.msg.success('¡Petición enviada con éxito! Template hello_world despachado.')
      }).catch(error => {
        let errData = error.response ? error.response.data : { error: { message: error.message || 'Error de conexión' } }
        self.respuesta_prueba = errData
        self.estado_respuesta_prueba = 'error'
        iu.msg.error('Error al enviar mensaje de prueba.')
      }).finally(() => {
        self.bandera_prueba = false
      })
    },

    sincronizarEstadoPlantillaConMeta() {
      let self = this
      let listado = self.plantillasMetaCargadas || []
      if (!listado || listado.length === 0) return

      self.plantillas.forEach(tpl => {
        let tplNombre = (tpl.nombre_meta || tpl.id).trim().toLowerCase()
        let tplIdioma = (tpl.idioma || 'es_MX').trim().toLowerCase()

        let coincidencia = listado.find(m =>
          (m.name || '').trim().toLowerCase() === tplNombre &&
          (m.language || '').trim().toLowerCase() === tplIdioma
        )

        if (coincidencia) {
          tpl.estado_meta = coincidencia.status
          tpl.id_meta = coincidencia.id
          tpl.idioma_registrado_meta = coincidencia.language
          if (coincidencia.category) tpl.categoria = coincidencia.category
        } else {
          tpl.estado_meta = 'NO_REGISTRADA'
          tpl.id_meta = null
        }
        if (!tpl.categoria) tpl.categoria = 'UTILITY'
      })

      self.actualizarAjustesPlantillasLocales()
    },

    alCambiarIdioma(nuevoIdioma) {
      let self = this
      let tpl = self.plantillaActual
      if (!tpl) return
      if (nuevoIdioma) tpl.idioma = nuevoIdioma

      if (self.plantillasMetaCargadas && self.plantillasMetaCargadas.length > 0) {
        self.sincronizarEstadoPlantillaConMeta()
      } else {
        if (tpl.idioma_registrado_meta && tpl.idioma !== tpl.idioma_registrado_meta) {
          tpl.estado_meta = 'NO_REGISTRADA'
          tpl.id_meta = null
        }
        if (self.ajustes.whatsapp_token && self.ajustes.whatsapp_business_account_id) {
          self.consultarEstadoPlantillasMeta(false)
        }
      }

      self.actualizarAjustesPlantillasLocales()

      if (tpl.estado_meta && tpl.estado_meta !== 'NO_REGISTRADA') {
        iu.msg.info(`Plantilla en Meta en idioma "${tpl.idioma}" (Estado: ${self.etiquetaEstadoMeta(tpl.estado_meta)}).`)
      } else {
        iu.msg.info(`Idioma "${tpl.idioma}" seleccionado. Use "Crear en Meta API" para registrarla.`)
      }
    },

    cambiarTab(tab) {
      this.tabActiva = tab
      if (tab === 'plantillas' && this.ajustes.whatsapp_activo && this.ajustes.whatsapp_token && this.ajustes.whatsapp_business_account_id) {
        this.consultarEstadoPlantillasMeta(false)
      }
    },

    consultarEstadoPlantillasMeta(abrirModal = true, forzar = false) {
      let self = this
      if (self.bandera_consultar_meta) return

      let ahora = Date.now()
      if (!abrirModal && !forzar && (ahora - self.ultimaConsultaMetaTimestamp < 30000)) {
        self.sincronizarEstadoPlantillaConMeta()
        return
      }

      self.bandera_consultar_meta = true
      let params = {
        phone_number_id: self.ajustes.whatsapp_phone_number_id || '',
        asset_id: self.ajustes.whatsapp_phone_number_id || '',
        waba_id: self.ajustes.whatsapp_business_account_id || '',
        token: self.ajustes.whatsapp_token || ''
      }

      SitioSrv.consultarPlantillasWhatsapp(params).then(response => {
        self.ultimaConsultaMetaTimestamp = Date.now()
        let listado = response.data && response.data.data ? response.data.data : []
        self.plantillasMetaCargadas = listado
        self.sincronizarEstadoPlantillaConMeta()

        if (abrirModal) {
          self.mostrarModalPlantillasMeta = true
          iu.msg.success(`Se consultaron ${listado.length} plantilla(s) desde Meta Cloud API.`)
        }
      }).catch(error => {
        if (abrirModal) {
          let errData = error.response ? error.response.data : { error: { message: error.message } }
          let msg = errData.error && errData.error.message ? errData.error.message : 'Error al consultar plantillas en Meta'
          iu.msg.error(msg)
        }
      }).finally(() => {
        self.bandera_consultar_meta = false
      })
    },

    crearPlantillaEnMeta(tpl) {
      let self = this
      let tplActual = tpl || self.plantillaActual || self.plantillas[self.plantillaSeleccionadaIdx]
      if (!tplActual) {
        iu.msg.warning('Seleccione una plantilla válida.')
        return
      }
      if (self.plantillaSeleccionadaIdx >= 0 && self.plantillas[self.plantillaSeleccionadaIdx]) {
        Object.assign(self.plantillas[self.plantillaSeleccionadaIdx], tplActual)
      }

      if (!self.ajustes.whatsapp_business_account_id || !self.ajustes.whatsapp_token) {
        iu.msg.warning('Configure WABA ID y Token en Credenciales.')
        return
      }
      if (!tplActual.cuerpo) {
        iu.msg.warning('El cuerpo del mensaje no puede estar vacío.')
        return
      }

      self.bandera_crear_meta = true
      self.respuestaMetaPlantilla = null

      let payload = {
        waba_id: self.ajustes.whatsapp_business_account_id || '',
        phone_number_id: self.ajustes.whatsapp_phone_number_id || '',
        token: self.ajustes.whatsapp_token || '',
        app_id: self.ajustes.whatsapp_app_id || '',
        name: tplActual.nombre_meta,
        category: tplActual.categoria || 'UTILITY',
        language: tplActual.idioma || 'es_MX',
        idioma: tplActual.idioma || 'es_MX',
        tipo_encabezado: tplActual.tipo_encabezado || 'NONE',
        encabezado: tplActual.tipo_encabezado === 'NONE' ? '' : (tplActual.encabezado || ''),
        url_imagen_encabezado: tplActual.tipo_encabezado === 'IMAGE' ? tplActual.url_imagen_encabezado : '',
        cuerpo: tplActual.cuerpo,
        pie: tplActual.pie || '',
        tiene_boton: false
      }

      SitioSrv.crearPlantillaWhatsapp(payload).then(response => {
        let res = response.data || {}
        tplActual.estado_meta = res.status || 'PENDING'
        tplActual.id_meta = res.id
        tplActual.idioma_registrado_meta = tplActual.idioma
        self.respuestaMetaPlantilla = res
        iu.msg.success(`¡Plantilla "${tplActual.nombre_meta}" enviada a Meta con éxito!`)

        let idx = self.plantillasMetaCargadas.findIndex(m =>
          (m.name || '').trim().toLowerCase() === (tplActual.nombre_meta || '').trim().toLowerCase() &&
          (m.language || '').trim().toLowerCase() === (tplActual.idioma || '').trim().toLowerCase()
        )
        let nuevoItem = {
          id: res.id,
          name: tplActual.nombre_meta,
          language: tplActual.idioma,
          category: tplActual.categoria || 'UTILITY',
          status: res.status || 'PENDING'
        }
        if (idx >= 0) {
          self.plantillasMetaCargadas.splice(idx, 1, nuevoItem)
        } else {
          self.plantillasMetaCargadas.push(nuevoItem)
        }

        self.actualizarAjustesPlantillasLocales()
      }).catch(error => {
        let errData = error.response ? error.response.data : { error: { message: error.message } }
        self.respuestaMetaPlantilla = errData
        let errObj = errData.error || {}
        let msg = errObj.error_user_msg || errObj.error_user_title || errObj.message || errData.message || 'Error al crear la plantilla en Meta'
        iu.msg.error(msg)
      }).finally(() => {
        self.bandera_crear_meta = false
      })
    },

    actualizarPlantillaEnMeta(tpl) {
      let self = this
      let tplActual = tpl || self.plantillaActual || self.plantillas[self.plantillaSeleccionadaIdx]
      if (!tplActual) {
        iu.msg.warning('Seleccione una plantilla válida.')
        return
      }
      if (self.plantillaSeleccionadaIdx >= 0 && self.plantillas[self.plantillaSeleccionadaIdx]) {
        Object.assign(self.plantillas[self.plantillaSeleccionadaIdx], tplActual)
      }

      if (!self.ajustes.whatsapp_business_account_id || !self.ajustes.whatsapp_token) {
        iu.msg.warning('Configure WABA ID y Token en Credenciales.')
        return
      }
      if (!tplActual.cuerpo) {
        iu.msg.warning('El cuerpo del mensaje no puede estar vacío.')
        return
      }

      self.bandera_actualizar_meta = true
      self.respuestaMetaPlantilla = null

      let payload = {
        waba_id: self.ajustes.whatsapp_business_account_id || '',
        phone_number_id: self.ajustes.whatsapp_phone_number_id || '',
        token: self.ajustes.whatsapp_token || '',
        app_id: self.ajustes.whatsapp_app_id || '',
        template_id: tplActual.id_meta,
        name: tplActual.nombre_meta,
        category: tplActual.categoria || 'UTILITY',
        language: tplActual.idioma || 'es_MX',
        idioma: tplActual.idioma || 'es_MX',
        tipo_encabezado: tplActual.tipo_encabezado || 'NONE',
        encabezado: tplActual.tipo_encabezado === 'NONE' ? '' : (tplActual.encabezado || ''),
        url_imagen_encabezado: tplActual.tipo_encabezado === 'IMAGE' ? tplActual.url_imagen_encabezado : '',
        cuerpo: tplActual.cuerpo,
        pie: tplActual.pie || '',
        tiene_boton: false
      }

      SitioSrv.actualizarPlantillaWhatsapp(payload).then(response => {
        let res = response.data || {}
        tpl.estado_meta = res.status || 'PENDING'
        if (res.id) tpl.id_meta = res.id
        tpl.idioma_registrado_meta = tpl.idioma
        self.respuestaMetaPlantilla = res
        iu.msg.success(`¡Plantilla "${tpl.nombre_meta}" actualizada en Meta con éxito!`)

        let idx = self.plantillasMetaCargadas.findIndex(m =>
          (m.name || '').trim().toLowerCase() === (tpl.nombre_meta || '').trim().toLowerCase() &&
          (m.language || '').trim().toLowerCase() === (tpl.idioma || '').trim().toLowerCase()
        )
        if (idx >= 0) {
          self.plantillasMetaCargadas[idx].status = res.status || 'PENDING'
        }

        self.actualizarAjustesPlantillasLocales()
      }).catch(error => {
        let errData = error.response ? error.response.data : { error: { message: error.message } }
        self.respuestaMetaPlantilla = errData
        let errObj = errData.error || {}
        let msg = errObj.error_user_msg || errObj.error_user_title || errObj.message || 'Error al actualizar la plantilla en Meta'
        iu.msg.error(msg)
      }).finally(() => {
        self.bandera_actualizar_meta = false
      })
    },

    confirmarEliminarPlantillaEnMeta(tpl) {
      let nombre = tpl.name || tpl.nombre_meta
      let id = tpl.id_meta || (tpl.id && !['confirmacion_pago', 'inicio_conversacion'].includes(tpl.id) ? tpl.id : null)
      let idioma = tpl.language || tpl.idioma || ''
      if (!nombre) return

      let labelIdioma = idioma ? ` (${idioma})` : ''
      Swal.fire({
        title: '¿Eliminar plantilla en Meta?',
        text: `Se eliminará la plantilla "${nombre}"${labelIdioma} de Meta WhatsApp Cloud API.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#74788d',
        confirmButtonText: '<i class="mdi mdi-trash-can me-1"></i> Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.ejecutarEliminarPlantillaEnMeta(nombre, id, idioma)
        }
      })
    },

    ejecutarEliminarPlantillaEnMeta(nombre, id, idioma) {
      let self = this
      self.bandera_eliminando_meta = id || nombre

      SitioSrv.eliminarPlantillaWhatsapp({ name: nombre, hsm_id: id }).then(() => {
        iu.msg.success(`Plantilla "${nombre}" eliminada exitosamente de Meta API.`)

        self.plantillas.forEach(p => {
          if ((p.nombre_meta === nombre || p.id === nombre) && (!idioma || p.idioma === idioma)) {
            p.estado_meta = 'NO_REGISTRADA'
            p.id_meta = null
            p.idioma_registrado_meta = null
          }
        })

        if (self.plantillaActual && (self.plantillaActual.nombre_meta === nombre || self.plantillaActual.id === nombre)) {
          self.plantillaActual.estado_meta = 'NO_REGISTRADA'
          self.plantillaActual.id_meta = null
          self.plantillaActual.idioma_registrado_meta = null
        }

        self.plantillasMetaCargadas = self.plantillasMetaCargadas.filter(m => {
          if (id && m.id === id) return false
          if (!id && m.name === nombre && (!idioma || m.language === idioma)) return false
          return true
        })

        self.actualizarAjustesPlantillasLocales()
      }).catch(error => {
        let errData = error.response ? error.response.data : { error: { message: error.message } }
        let errObj = errData.error || {}
        let msg = errObj.error_user_msg || errObj.error_user_title || errObj.message || 'Error al eliminar la plantilla en Meta'
        iu.msg.error(msg)
      }).finally(() => {
        self.bandera_eliminando_meta = null
      })
    }
  }
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}
</style>
